import { useState } from "react";

const dismissalKey = "admin-legacy-notice-dismissed";

// Session storage can be unavailable (blocked site data, some private windows);
// the notice then shows on every screen and Dismiss hides it until the next one.
const readIsDismissed = (): boolean => {
  try {
    return sessionStorage.getItem(dismissalKey) === "true";
  } catch {
    return false;
  }
};

const storeDismissal = () => {
  try {
    sessionStorage.setItem(dismissalKey, "true");
  } catch {
    // The notice is still hidden for this screen.
  }
};

// Whether the admin dismissed the legacy admin notice, which holds for the rest of
// the browser tab's session, reloads included (SHELL-R26).
export const useLegacyAdminNoticeDismissal = () => {
  const [isDismissed, setIsDismissed] = useState(readIsDismissed);

  const dismiss = () => {
    storeDismissal();
    setIsDismissed(true);
  };

  return { isDismissed, dismiss };
};
